import Script from 'next/script'
import { TRACKING_CONFIG } from '@/config/tracking.config'

export const Hotjar = () => (
  <Script
    id="hotjar"
    strategy="afterInteractive"
    dangerouslySetInnerHTML={{
      __html: `
        (function(h,o,t,j,a,r){
          h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
          h._hjSettings={hjid:${TRACKING_CONFIG.hotjar.id},hjsv:${TRACKING_CONFIG.hotjar.version}};
          a=o.getElementsByTagName('head')[0];
          r=o.createElement('script');r.async=1;
          r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
          a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
      `,
    }}
  />
) 